import React, { Component } from 'react'; 
import { withstyles, Paper, Typography, Button, Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, withStyles, TextField, MenuItem, Grid, Divider,
Table, TableBody, TableCell, Checkbox, TableRow, TablePagination, TableHead, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@material-ui/core';
import { } from '@material-ui/icons';
import creds from '../config/firebaseConfig';
import db from '../config/firestoreConfig';


const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        position: 'relative',
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        margin: 'auto',
        width: '75%',
    },
    container: {
        display: 'block',
        flexWrap: 'wrap',
        width: '100%',
        padding: 10,
        margin: 'auto',
        alignItems: 'center',
        alignContent: 'center',
        overflowX: 'auto'
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 300,
        padding: 5,
    },
    table: {
        overflowX: 'auto',
        flexWrap: 'wrap'
    }
})

let id = 0;


class editAccount extends Component{
    constructor(props){
        super(props)
        this.state = {
            selected: [], 
            selectedUser : {
                displayName : '',
                password: '',
                email: '',
                accountType: '',
                UID: '',
            },
            newUser : {

            },
            rowsPerPage : 10,
            page : 0,
            searchPhrase : '',
            checkedList : [],
            open: false,
            abilityArr : ['Beginner', 'Intermediate', 'Advanced'],
            levelsArr: [] 
        }
        
    }

    componentDidMount(){
        var userlist = []
        var levels = [] 
        var output = []
        db.collection('Users').get()
        .then( snapshot => { 
            snapshot.forEach( doc => { 
                userlist.push(doc.data())
            })
            // console.log(userlist)
            this.setState({
                ...this.state,
                userlist: userlist,
            })
        })
        db.collection('Level').get()
        .then( snapshot => {
            snapshot.forEach(Lvl => {
                var subjyrs = []
                var ll = [] 
                levels.push(Lvl.id)
                db.collection('Level').doc(Lvl.id).collection('Subjects').get()
                .then( snapshot => { 
                    snapshot.forEach( subj => {
                        db.collection('Level').doc(Lvl.id).collection('Subjects').doc(subj.id).collection('Years').get()
                        .then(snapshot => { 
                            snapshot.forEach( yr => { 
                                // console.log('ID', yr, yr.id)
                                subjyrs.push(yr.id)
                            })
                            // console.log('SUBJYRS', subjyrs)
                            ll.push(subjyrs)
                        })
                    })
                    
                })
                output.push(ll)
            })
            
        })
        this.setState({
            ...this.state,
            levelsArr : levels,
            ll : output,
            open: false
        })
    }

    


    createData(name, accountType, currentLvl, year, email) {
        id += 1;
        return {id, name, accountType, currentLvl, year, email }; 
    }

    //ITEMS FOR THE TABLE   
    rows = (arr) => {
        const output = []
        // console.log(arr);
        arr.map(record => {
            output.push(
                this.createData(record.displayName, record.accountType, record.CurrentLevel, record.CurrentYear, record.email)
            )
        })
        return output
    }

    searchArr = (arr, searchTerm ) => {
        console.log(searchTerm)
        searchTerm = searchTerm.toLowerCase()
        var output = [];
        arr.forEach(e => {
            if (e.name.toLowerCase().search(searchTerm) != -1) {
                output.push(e)
            }
        })
        return output
    }

    checked = () => event => {
        console.log(this.state)
        var arr = this.state.checkedList;
        console.log(arr)
        const index = arr.indexOf(event.target.value)
        var index2
        this.state.userlist.forEach(user => { 
            if (user.displayName == event.target.value) {
                console.log('USER', user)
                return index2 = this.state.userlist.indexOf(user)
            }
        })
        // console.log('INDEX', index2, this.state.userlist[index2], arr[0])
        var thisUser = this.state.userlist[index2]
        // console.log(index)
        if  (index != -1) {
            arr.splice(index, 1)
        } else {
            if (arr.length < 1) {
                arr.push(event.target.value)
            } else {
                window.alert('You may only edit 1 record at a time')
            }
        }
        // console.log(arr)
        this.setState({
            checkedList: arr,
            open: true,
            selectedUser: thisUser
        })
        // console.log(this.state.checkedList)
        // console.log(this.state)

    }

    handleChangeUser = name => event => {
        this.setState({
            ...this.state,
            selectedUser: {
                ...this.state.selectedUser,
                [name]: event.target.value
            }
        })
    }

    handleChange = name => event => {
        this.setState({
            ...this.state,
            [name]: event.target.value,
            nameErr: false,
            emailErr: false,
            passwordErr: false,
            targetErr: false
        })
    }

    makeTableData = () => {
        return this.searchArr(this.rows(this.state.userlist), this.state.searchPhrase)
        
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };
    
    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleClose = () => { 
        this.setState({
            ...this.state,
            open: false,
            checkedList: []
        })
    }

    finishUp = async () => {
        console.log(this.state.selectedUser, this.state)
        var selectedUser = this.state.selectedUser;
        var displayName = this.state.displayName;
        var CurrentYear = this.state.CurrentYear;
        var CurrentLevel = this.state.CurrentLevel;
        var ability = this.state.ability;
        var password = this.state.password;
        var target = this.state.target;

        if (!displayName){
            displayName = this.state.selectedUser.displayName
        }
        if (!CurrentLevel){
            CurrentLevel = this.state.selectedUser.CurrentLevel
        }
        if (!CurrentYear){
            CurrentYear = this.state.selectedUser.CurrentYear
        }
        if (!ability){
            ability = this.state.selectedUser.ability
        }
        if (!target){
            target = this.state.selectedUser.target
        }
        if (!password){
            console.log('CONSOLE', password, this.state.selectedUser.password)
            password = this.state.selectedUser.password
        }

        if (!displayName || displayName.length < 1){
            return this.setState({
                ...this.state,
                nameErr: true
            })
        }  else
        if (!password || !password.length > 5){
            return this.setState({
                ...this.state,
                passwordErr: true
            })
        } else
        if (this.state.selectedUser.accountType == 'Student') {
            if (!ability || !ability.length > 0){
            return this.setState({
                ...this.state,
                abilityErr: true
            })
            } 
            if (!target || target == 0){
                return this.setState({
                    ...this.state,
                    targetErr: true
                })
            }
        }
        var obj = {}
        if (this.state.selectedUser.accountType == 'Student'){
            obj = {
                UID: this.state.selectedUser.UID,
                displayName : displayName,
                CurrentLevel: CurrentLevel,
                CurrentYear: CurrentYear,
                ability: ability,
                target: target,
                email: this.state.selectedUser.email,
                password: password,
                accountType: this.state.selectedUser.accountType
            }
            this.updateRecords(displayName, this.state.selectedUser.UID)
        } else {
            obj = {
                UID: this.state.selectedUser.UID,
                displayName : displayName,
                email: this.state.selectedUser.email,
                password: password,
                accountType: this.state.selectedUser.accountType
            }
        }

        var ref = await db.collection('Users')
        ref.get()
        .then( snapshot => { 
            snapshot.forEach(doc => { 
                if (doc.data().UID == this.state.selectedUser.UID){
                    // console.log('MATCH', doc.id) // debug
                    var toUpload = Object.assign(doc.data(), obj)
                    console.log('TO UPLOAD', toUpload)
                    db.collection('Users').doc(doc.id).set(toUpload)
                    .then(() => {
                        this.callAlert('Changes Saved')
                        window.location.reload()
                    })
                    .catch(err => {
                        console.error(err)
                        window.alert('There was an error. Please see the console for more details.')
                    })
                }
            })
        })
    }

    updateRecords = async (name, uid) => { 
        console.log(name, uid, 'STARTED')
        var snapshot = await db.collection('Users').where('accountType', '==', 'Parent').get()
        snapshot.forEach( parent => {
            var data = parent.data()
            if (data.children) {
                var id = parent.id
                var children = data.children;
                children.forEach( child => { 
                    if ((child.value === uid && child.name != name) || (child.value === uid && child.label != name)){
                        console.log('338', child, name, uid)
                        child.name = name
                        child.label = name
                    }
                })
                data.children = children
                db.collection('Users').doc(id).set(data)
                .then(function(){
                    window.alert('Parent record updated successfully.')
                })
                .catch(function(err){
                    console.error(err.message)
                    window.alert('There was an error. Please see the developer console for more info.')
                })
            }
        })

        snapshot = await db.collection('AssignedTasks').get()
        snapshot.forEach( test => {
            var id = test.id;
            var updated = false;
            var testData = test.data()
            testData.AssignedTo.forEach( student => {
                if (student.Student == uid && student.displayName != name){
                    student.displayName = name
                    console.log('UPDATED', testData)
                    return updated = true
                }
            })
            if (updated){
                db.collection('AssignedTasks').doc(id).set(testData)
                .then( function(){
                    this.callAlert('Assigned Tasks updated')
                }).bind(this)
                .catch(function(err){
                    console.error(err.message)
                    this.callAlert('There was an error updating some of the database records')
                }).bind(this)
            }
        })

        snapshot = await db.collection('WorkGroups').get()
        snapshot.forEach( group => { 
            var id = group.id
            var updated = false;
            var data = group.data()
            data.Members.forEach( student => {
                if (student.uid == uid && student.Name != name){
                    student.Name == name
                    return updated = true
                }
            })
            if (updated){
                db.collection('WorkGroups').doc(id).set(data)
                .then( function(){
                    this.callAlert('Work Groups updated')
                }).bind(this)
                .catch(function(err){
                    console.error(err.message)
                    this.callAlert('There was an error updating some of the database records')
                }).bind(this)
            }
        })
    }

    callAlert = message => {
        window.alert(message)
        // setTimeout(this.componentDidMount(), 1000)
    }

    render(){
        const { classes } = this.props;
        return (
            <div>
                {(this.state.userlist ? 
                    <Paper className={classes.root} elevation={1}>
                        <Typography variant='headline'>
                            Edit User Accounts
                        </Typography>
                        <Divider/>
                        <br/>
                            <TextField className={classes.TextField}
                                onChange={this.handleChange('searchPhrase')}
                                value={this.state.searchPhrase}
                                helperText='Search for Accounts via dislay name'
                            />
                            <br/>
                            <br/>
                            <Paper style={{overflowX: 'auto'}}>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell><Checkbox disabled={true}/></TableCell>
                                        <TableCell>User</TableCell>
                                        <TableCell>Account Type</TableCell>
                                        <TableCell>Current Level</TableCell>
                                        <TableCell>Current Year</TableCell>
                                        <TableCell>Email</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.makeTableData()
                                        .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                        .map(row => {
                                        return (
                                            
                                            <TableRow 
                                                key={row.id}
                                                hover
                                                tabIndex={-1}>
                                                <TableCell><Checkbox  value={row.name} onChange={this.checked()} checked={(this.state.checkedList.indexOf(row.name) != -1)}/></TableCell>
                                                <TableCell component="th" scope="row">
                                                {row.name}
                                                </TableCell>
                                                <TableCell>{row.accountType}</TableCell>
                                                <TableCell>{row.currentLvl}</TableCell>
                                                <TableCell>{row.year}</TableCell>
                                                <TableCell>{row.email}</TableCell>
                                                
                                            </TableRow>
                                            
                                        )
                                    })}
                                 </TableBody>   
                            </Table>
                            <TablePagination
                                component='div'
                                count={this.makeTableData().length}
                                rowsPerPage={this.state.rowsPerPage}
                                page={this.state.page}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                  }}
                                  nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                  }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                  />
                                  </Paper>
                                <br/>
                                <Button variant='raised' onClick={() => this.deleteSelected(this.state.checkedList)}>
                                        Edit Selected
                                </Button>
                    </Paper>
                :
                
                <div/>)}
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title"> Edit Account </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Edit existing user records and save changes directly to the database. Ability to edit email is disabled.
                        </DialogContentText>
                        <br/>
                        <TextField
                            id='username'
                            label='Display Name'
                            defaultValue={this.state.selectedUser.displayName}
                            value={this.state.displayName}
                            className={classes.textField}
                            onChange={this.handleChange('displayName')}
                            margin='normal'
                            error={this.state.nameErr}
                        />
                        <br/>
                         <TextField
                            id='email'
                            label='Email'
                            defaultValue={this.state.selectedUser.email}
                            disabled={true}
                            value={this.state.selectedUser.email}
                            className={classes.textField}
                            onChange={() => this.handleChange('email')}
                            margin='normal'
                            error={this.state.emailErr}
                        />
                        <br/>
                        <TextField
                            id='password'
                            label='Password'
                            defaultValue={this.state.selectedUser.password}
                            value={this.state.password}
                            className={classes.textField}
                            onChange={this.handleChange('password')}
                            margin='normal'
                            error={this.state.passwordErr}
                        />
                        <br/>
                        {this.state.selectedUser.accountType == 'Student' ? 
                        <div>
                        <TextField
                            select
                            id='level'
                            helperText='Level'
                            value={this.state.CurrentLevel}
                            // defaultValue={this.state.selectedUser.CurrentLevel}
                            onChange={this.handleChange('CurrentLevel')}
                            className={classes.textField}
                            margin='normal'
                            error={this.state.passwordErr}
                        >
                            {this.state.levelsArr.map(level => { 
                                return (
                                    <MenuItem key={this.state.levelsArr.indexOf(level)} value={level}>
                                        {level}
                                    </MenuItem>
                                )
                            })}
                        </TextField>
                        <br/>
                        <TextField
                            select
                            id='year'
                            helperText='Year'
                            defaultValue={this.state.selectedUser.CurrentYear}
                            value={this.state.CurrentYear}
                            className={classes.textField}
                            onChange={this.handleChange('CurrentYear')}
                            margin='normal'
                            error={this.state.passwordErr}
                        >
                        {this.state.CurrentLevel ? 
                            this.state.ll[this.state.levelsArr.indexOf(this.state.CurrentLevel)][0].map(yr => { 
                                return (
                                    <MenuItem key={this.state.ll.indexOf(yr)} value={yr}>
                                        {yr}
                                    </MenuItem>
                                )
                            })
                        :
                            <div/>
                        }
                        
                        </TextField>
                        <br/>
                        <TextField
                            id='ability'
                            helperText='Ability'                            
                            value={this.state.selectedUser.ability}
                            className={classes.textField}
                            onChange={this.handleChangeUser('ability')}
                            margin='normal'
                            error={this.state.abilityErr}
                            select
                        >
                            {this.state.selectedUser.CurrentYear ? 
                                this.state.abilityArr.map(ability => { 
                                    return (
                                        <MenuItem key={ability} value={ability}>
                                            {ability}
                                        </MenuItem>
                                    )
                                })
                            :
                                <div/>
                            }
                        </TextField>
                        <br/>
                        <TextField
                            id='target'
                            type='number'
                            label='Target Grade'
                            defaultValue={this.state.selectedUser.target}
                            value={this.state.target}
                            className={classes.textField}
                            onChange={this.handleChange('target')}
                            margin='normal'
                            error={this.state.targetErr}
                        />
                        </div>
                        :
                        <div/>
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button variant='raised' onClick={() => this.finishUp()}>
                                Save Changes
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}
export default withStyles(styles)(editAccount);


// WEBPACK FOOTER //
// ./src/admin/editAccount.jsx